/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_CutInputs */



/**
* | output |
* | --- |
* | "Cut" |
*
* @param {Shortcut_Keys_Name_CutInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_cut = /** @type {((inputs?: Shortcut_Keys_Name_CutInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_CutInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Couper")
	if (locale === "de") return /** @type {LocalizedString} */ ("Schneiden")
	if (locale === "it") return /** @type {LocalizedString} */ ("Taglio")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Резать")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cortar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("切")
	if (locale === "ja") return /** @type {LocalizedString} */ ("カット")
	if (locale === "hi") return /** @type {LocalizedString} */ ("काटना")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Corte")
	return /** @type {LocalizedString} */ ("Cut")
});